export class DocumentUpload {
    public ID: number;
    public HashCode: string;
    public DocumentName: string;
    public YearID: number;
}